import {IProtocolStepKind} from "./types/protocol";
import classes from "./modals.module.css";
import {Button, Text, Tooltip} from "@mantine/core";
import {StepIcon} from "./common/StepIcon";
import {IconArrowRight} from "@tabler/icons-react";
import {v4 as uuidv4} from "uuid"
import {modals} from "@mantine/modals";
import {useNeurotuneStore} from "@/common/store/neurotune";
import {isAria} from "@/common/utils/companies";


export const showAddStepModal = (
    onSelected: (kind: IProtocolStepKind, name: string) => void,
    activeCompany?: {id: string}
) => {
    const modalId = uuidv4()
    const company = activeCompany ?? useNeurotuneStore.getState().activeCompany;
    const isAriaCompany = isAria(company);

    const onSelect = (kind: IProtocolStepKind, name: string) => {
        onSelected(kind, name);
        modals.close(modalId)
    }
    return modals.open({
        modalId,
        title: "Select Step Type",
        size: "md",
        radius: "md",
        children: (
            <div className={classes.stepInsertionList}>
                <Tooltip label="A Logical Grouping of Steps.">
                    <Button leftSection={<StepIcon kind={IProtocolStepKind.GROUP}/>}
                            rightSection={<IconArrowRight/>}
                            onClick={() => onSelect(IProtocolStepKind.GROUP, "Group")}>
                        Group
                    </Button>
                </Tooltip>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.STIM_EVENT}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.STIM_EVENT, "Stimulation")}>
                    Stimulation
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.MEASURE_HR}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.MEASURE_HR, "Heart Rate Check")}>
                    Measure Heart Rate
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.MEASURE_BP}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.MEASURE_BP, "Blood Pressure Check")}>
                    Measure BP
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.MEASURE_PLR}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.MEASURE_PLR, "Pupillometry")}>
                    Pupillometry
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.NRS_PAIN_SCORE}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.NRS_PAIN_SCORE, "NRS Pain Score")}>
                    NRS Pain Score
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.PP_RELIEF}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.PP_RELIEF, "PP Relief")}>
                    PP Relief
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.REST_EVENT}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.REST_EVENT, "Rest Period")}>
                    Rest Period
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.QUESTIONNAIRE}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.QUESTIONNAIRE, "Questionnaire")}>
                    Questionnaire
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.START_DATA_COLLECTION}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.START_DATA_COLLECTION, "Start Data Collection")}>
                    Start Data Collection
                </Button>
                <Button leftSection={<StepIcon kind={IProtocolStepKind.STOP_DATA_COLLECTION}/>}
                        rightSection={<IconArrowRight/>}
                        onClick={() => onSelect(IProtocolStepKind.STOP_DATA_COLLECTION, "Stop Data Collection")}>
                    Stop Data Collection
                </Button>
                <Tooltip label="Add instructions for the operator.">
                    <Button leftSection={<StepIcon kind={IProtocolStepKind.INSTRUCTIONS}/>}
                            rightSection={<IconArrowRight/>}
                            onClick={() => onSelect(IProtocolStepKind.INSTRUCTIONS, "Instructions")}>
                        Instructions
                    </Button>
                </Tooltip>
                {isAriaCompany && (
                    <Button leftSection={<StepIcon kind={IProtocolStepKind.PORT_CONFIG}/>}
                            rightSection={<IconArrowRight/>}
                            onClick={() => onSelect(IProtocolStepKind.PORT_CONFIG, "Port Configuration")}>
                        Port Configuration
                    </Button>
                )}

            </div>
        )
    })
}

export const openConfirmModal = ({
                                     size = "md",
                                     zIndex = "1000",
                                     withCloseButton = false,
                                     labels = {
                                         confirm: "Confirm",
                                         cancel: "Cancel"
                                     },
                                     ...others
                                 }: any) => {
    return modals.openConfirmModal({
        classNames:{
            content: 'bios-confirm-modal'
        },
        size,
        zIndex,
        withCloseButton,
        labels,
        ...others,
    })
}